module.exports = __webpack_public_path__ + "media/img/logos/2024/jobboerse-stellenangebote-berufseinsteiger-swiss_day-060bafc1f0d53d5e6d724ed7113573bd.svg";